<template>
  <div>
    <el-form class="login-container" label-position="left"
             label-width="0px">
      <h3 class="login_title">OP数据上报demo</h3>
      <el-form-item>
        <el-input type="text" v-model="ggzinput"
                  auto-complete="off" placeholder="广告主id"></el-input>
      </el-form-item>
      <el-form-item>
        <el-input type="text" v-model="myurl"
                  auto-complete="off" placeholder="url"></el-input>
      </el-form-item>
      <el-form-item>
        <el-select v-model="values" placeholder="上报类型">
          <el-option
            v-for="items in level"
            :key="items.value"
            :label="items.label"
            :value="items.value">
          </el-option>
        </el-select>
      </el-form-item>
      <el-button type="success" v-on:click="update">
        用户上报
      </el-button>
    </el-form>
  </div>
</template>
<script>
import sha1 from "js-sha1";
import {Base64} from "js-base64";
import axios from "axios";
export default {
  data() {
    return {
      myurl:'',
      input: '',
      input1:'',
      input2: '',
      input3:'',
      input4: '',
      input5:'',
      ggzinput:'',
      values:'',
      level: [{
        value: 101,
        label: '表单提交'
      }, {
        value: 102,
        label: '表单关键行为'
      },
        {
          value: 105,
          label: '表单-网页购买'
        },],
    }
  },
  methods: {
    update() {
      function getQueryParams(url) {
        let params = {};
        let queryString = url.split('?')[1]; // 获取查询字符串部分
        if (queryString) {
          let pairs = queryString.split('&'); // 按&符号分割
          pairs.forEach(pair => {
            let [key, value] = pair.split('=');
            params[key] = value; // 保存每个键值对
          });
        }
        return params;
      }
      let params = getQueryParams(this.myurl);
      let parms={
        oid:'1000166356',
        apiid:'f00927ea6e0641ec9d06752695cc9ebc',
        apikey:'fa1c6a08754f48b49345800a2f96bc3a',
        lbid:"1_0_0",
        tid:params.tid,
        pageId:params.pageId,
        ggzinput:this.ggzinput
      }
      console.log(parms)
      this.PostMoeny(parms)
    },
    //用户上报
    async PostMoeny(parms){
      console.log(parms)
      let time1 = parseInt(new Date().getTime()) + '';
      time1=parseInt(time1/1000);
      let sign= sha1(parms.apiid + parms.apikey + time1);
      let token=Base64.encode(parms.oid + "," + parms.apiid + "," + time1 + "," + sign);

      const config = {
        headers:{
          'Authorization': "Bearer "+token,  //这里是关键,设置好Authorization,将定义的token放在后面即可
        }
      };
      ///?extensionType=2&dayBudget=155500&planName=123&dayLimit=1
      await axios.post('apis/v1/clue/sendData', {
        "ip":"127.0.0.1",
        "transformType":this.values,
        "ownerId": parms.ggzinput,
        "pageId": parms.pageId,
        "tid": parms.tid,
        "lbid":"1_0_0"
        },config
      ).then(res => {
        this.$notify({
          title: '成功',
          message: '上传成功',
          type: 'success'
        });
      })

    },
  }
}
</script>

<style>
.login-container {
  border-radius: 15px;
  background-clip: padding-box;
  margin: 90px auto;
  width: 350px;
  padding: 35px 35px 15px 35px;
  background: #fff;
  border: 1px solid #eaeaea;
  box-shadow: 0 0 25px #cac6c6;
}
#poster {
  background-position: center;
  height: 100%;
  width: 100%;
  background-size: cover;
  position: fixed;
}
body{
  margin: 0px;
}
.login_title {
  margin: 0px auto 40px auto;
  text-align: center;
  color: #505458;
}

</style>
<style scoped="scoped">
.btn-upload {
  z-index: 100;
  border-radius: 30px;
  box-shadow: 0 2px 12px 0 rgba(91, 156, 255, 0.9)
}

.el-upload {
  margin: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/oppoupdate.vue